import { useQuery } from '@tanstack/react-query';
import { useQueryCreator } from '~/hooks/useQueryCreator';
import { fulfillmentContextService } from '~/services';
import type { PartnerLaneOrchestration } from '@shipium-corp/shipium-ts-types';
import { DOCK_LANES_QUERY_KEY } from './dockLaneQueryKeys';

export { DOCK_LANES_QUERY_KEY };

const dockLanesQuery = {
  queryKey: DOCK_LANES_QUERY_KEY,
  configurationType: 'cached' as const,
  fn: (tenantId?: string): Promise<PartnerLaneOrchestration[]> => fulfillmentContextService.fetchDockLanes(tenantId),
};

export const useDockLanes = (tenantId?: string) => {
  return useQuery({
    ...useQueryCreator(dockLanesQuery, {
      args: [tenantId],
    }),
  });
};
